__turbopack_context__.v({
  "dark-mode": "react-date-picker-overwrite-module-scss-module__1lhYzW__dark-mode",
  "date-picker": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker",
  "date-picker-day-number": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker-day-number",
  "date-picker-day-passive": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker-day-passive",
  "date-picker-month-picker": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker-month-picker",
  "date-picker-month-year-wrapper": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker-month-year-wrapper",
  "date-picker-next-button": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker-next-button",
  "date-picker-prev-button": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker-prev-button",
  "date-picker-year-picker": "react-date-picker-overwrite-module-scss-module__1lhYzW__date-picker-year-picker",
  "light-mode": "react-date-picker-overwrite-module-scss-module__1lhYzW__light-mode",
});
